export interface SegmentOption<T extends string> {
    value: T;
    label: string;
}

export interface SegmentToggleProps<T extends string> {
    options: SegmentOption<T>[];
    value: T;
    onChange: (value: T) => void;
    /** Gold styling, used by the All-Time "hall of fame" window. */
    gold?: boolean;
    testId?: string;
    /** Describes what the toggle switches, for screen readers. */
    label: string;
}

/**
 * The design's pill toggle (reference/02 `.seg`).
 *
 * Real buttons in a `tablist` rather than `IonSegment`: `IonSegment` brings its own shadow-DOM
 * styling that fights the design's flat pill, and this needs no gesture support.
 */
export function SegmentToggle<T extends string>({
    options,
    value,
    onChange,
    gold,
    testId,
    label,
}: SegmentToggleProps<T>) {
    return (
        <div
            className={`venue-seg${gold ? " venue-seg-gold" : ""}`}
            role="tablist"
            aria-label={label}
            data-testid={testId}
        >
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    role="tab"
                    aria-selected={option.value === value}
                    className={
                        option.value === value ? "venue-seg-active" : undefined
                    }
                    data-testid={
                        testId ? `${testId}-${option.value}` : undefined
                    }
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
